import { render, staticRenderFns } from "./DetailAccount.vue?vue&type=template&id=950a05ba&"
import script from "./DetailAccount.vue?vue&type=script&lang=js&"
export * from "./DetailAccount.vue?vue&type=script&lang=js&"
import style0 from "./DetailAccount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports